import closeAllMenus from '../../core/INF-closeAllMenus';

export default () => {
  // Trigger 'shoppableImageWillClose' event
  const shoppableImageWillCloseEvent = new Event('shoppableImageWillClose');
  document.dispatchEvent(shoppableImageWillCloseEvent);

  const modal = document.querySelector('[data-shoppable-image-modal]');

  closeAllMenus();

  // Remove 'State--shoppable-image-open' class from all elements with 'data-state' attribute
  document.querySelectorAll('[data-state]').forEach((element) => {
    element.classList.remove('State--shoppable-image-open');
  });

  // Remove classes from the modal
  modal.classList.remove('ShoppableModal--Active', 'Modal--open');
  modal.querySelectorAll('[data-will-animate]').forEach((element) => {
    element.classList.remove('Animate', 'Animate--slide-up', 'Animate--animated');
  });

  // Trigger scroll event
  const scrollEvent = new Event('scroll');
  document.dispatchEvent(scrollEvent);

  // Trigger 'shoppableImageDidClose' event
  const shoppableImageDidCloseEvent = new Event('shoppableImageDidClose');
  return document.dispatchEvent(shoppableImageDidCloseEvent);
};
